import React, { PropsWithChildren, useEffect } from 'react';
import { useAppActions, useAppState } from '../../overmind';
import { Navigate } from 'react-router';
import { PagePath } from '../navigation.enums';
import { IAnalysisPageGuardProps } from './guards.models';

export function AnalysisPageGuard(props: PropsWithChildren<IAnalysisPageGuardProps>): JSX.Element {
  const { assessmentRequired, assessmentTypeRequired, children } = props;

  const { activeAssessmentConfig, forcedAssessments } = useAppState();
  const actions = useAppActions();
  
  useEffect(() => {
    if (forcedAssessments.length === 1 && !activeAssessmentConfig) {
      actions.getAssessmentConfig(forcedAssessments[0].assessmentSlug);
    }
  }, [forcedAssessments, activeAssessmentConfig]);

  if (forcedAssessments.length === 1 && !activeAssessmentConfig) {
    return <Navigate to={PagePath.analysisBase + PagePath.analysisAssessment.replace(':assessmentSlug', forcedAssessments[0].assessmentSlug)} />;
  }

  if (!forcedAssessments.length && !activeAssessmentConfig) {
    return <Navigate to={PagePath.yourSkills} />;
  }

  if (assessmentRequired && !activeAssessmentConfig) {
    if (forcedAssessments.length > 1) {
      return <Navigate to={PagePath.analysisBase + PagePath.analysisPendingAssessments} />;
    }

    return <Navigate to={PagePath.yourSkills} />;
  }

  if (assessmentTypeRequired !== undefined && activeAssessmentConfig?.assessmentType !== assessmentTypeRequired) {
    if (!activeAssessmentConfig) {
      if (forcedAssessments.length > 1) {
        return <Navigate to={PagePath.analysisBase + PagePath.analysisPendingAssessments} />;
      }

      return <Navigate to={PagePath.yourSkills} />;
    }

    if (forcedAssessments.length > 1) {
      return <Navigate to={PagePath.analysisBase + PagePath.analysisAssessment.replace(':assessmentSlug', activeAssessmentConfig.assessmentSlug)} />;
    }

    return <Navigate to={PagePath.analysisBase + PagePath.analysisAssessment.replace(':assessmentSlug', activeAssessmentConfig.assessmentSlug)} />;
  }

  return <React.Fragment>{children}</React.Fragment>;
}
